import {
  formatCpf,
  formatMoney,
  formatName,
} from "../../../../services/functions";


import { SubscriberController } from "../../../../services/controllers/subscription";
import { useSubscribers } from "../../../../store/subscription/useSubscribers";

import { Table } from "../../../../components/ui/Table";
import { Pagination } from "../../../../components/ui/Pagination";

import { Status } from "../Status";

import { SubscriberActions } from "./SubscriberActions";
import { TwoColuns } from "./styles";
import { twMerge } from "tailwind-merge";
import { UserRoundCog } from "lucide-react";
import { CustomerDetailsController } from "../../../../services/controllers/customer";

const SORTABLE_COLUMN_KEYS = {
  "Data": "createdAt",
  "CPF": "cpf",
  "Cliente": "customerName",
  "Pet": "petName",
  "Porte": "size",
  "Vendedor": "saller",
  "Plano": "planType",
  "Preço": "planPrice",
  "Disponíveis": "avaliableBath",
  "Cobrança": "nextBillingAt",
  "Cancelamento": "canceledAt",
  "Ativo até": "validUntilDate",
  "Status": "status",
};

export function SubscribersTable() {
  const CSubscriber = SubscriberController();
  const CCustomerDetails = CustomerDetailsController();

  const page = useSubscribers((st) => st.data.pagination.page);
  const isWaiting = useSubscribers((st) => st.data.isWaiting);
  const paginationData = useSubscribers((st) => st.data.pagination);
  const sort = useSubscribers((st) => st.data.sort);

  const subscribers = useSubscribers((st) => st.data.subscribers);

  return (
    <Table.Root name={CSubscriber.tableName} config customActions>
      <Table.Header
        columns={[
          "Data:100px",
          "CPF:140px:true",
          "Cliente:minmax(150px, 260px)",
          "Pet:minmax(105px, 200px)",
          "Porte:100px:true",
          "Vendedor:minmax(120px, 200px):true",
          "Plano:100px:true",
          "Preço:90px:true",
          "Disponíveis:105px:true",
          "Cobrança:110px:true",
          "Cancelamento:115px",
          "Ativo até:105px",
          "Status:120px",
          ":210px"
        ]}
        sortableConfig={{
          sortBy: sort.sortBy,
          sortOrder: sort.sortOrder,
          onSort: CSubscriber.handleSortColumn,
          columnKeys: SORTABLE_COLUMN_KEYS,
        }}
      />
      <Table.Content isLoading={isWaiting}>
        {!!subscribers[page] &&
          subscribers[page].map((subscriber) => (
            <Table.Line
              key={subscriber.id}
              data-status={subscriber.status}
              data-canceled={!!subscriber.canceledAt}
              className={twMerge(
                "group",
                "data-[status=Em_atraso]:text-amber-500 data-[status=Em_atraso]:hover:bg-yellow-400 data-[status=Em_atraso]:hover:text-white",
                "data-[status=Cancelado]:text-rose-600 data-[status=Cancelado]:hover:bg-rose-500 data-[status=Cancelado]:hover:text-white",
                "data-[canceled=true]:text-rose-600 data-[canceled=true]:hover:bg-rose-500 data-[canceled=true]:hover:text-white",
              )}
            >
              <Table.Item>{subscriber.createdAt}</Table.Item>
              <Table.Item>
                <button type="button" className="font-medium flex gap-1 items-center border-b border-transparent hover:border-current" onClick={() => CCustomerDetails.open(subscriber.customer.id)}>
                  <UserRoundCog aria-hidden="true" size={16} />
                  {formatCpf(subscriber.customer.cpf)}
                </button>
              </Table.Item>
              <Table.Item>
                <button type="button" className="flex gap-1 items-center border-b border-transparent hover:border-current" onClick={() => CCustomerDetails.open(subscriber.customer.id)}>
                  <UserRoundCog aria-hidden="true" size={16} />
                  {formatName(subscriber.customer.name.firstname)}
                </button>
              </Table.Item>
              <Table.Item>{formatName(subscriber.pet.name)}</Table.Item>
              <Table.Item>{subscriber.pet.size.join(', ')}</Table.Item>
              <Table.Item className="text-nowrap">{formatName(subscriber.saller || '-')}</Table.Item>
              <Table.Item>{formatName(subscriber.plan.type)}</Table.Item>
              <Table.Item>{formatMoney(subscriber.plan.price)}</Table.Item>
              <Table.Item>
                <strong>{subscriber.plan.avaliableBath} </strong>
                {subscriber.plan.avaliableBathText}
              </Table.Item>
              <Table.Item>{subscriber.nextBillingAt || '-'}</Table.Item>
              <Table.Item className="group-data-[status=Cancelado]:font-bold group-data-[canceled=true]:font-bold">{subscriber.canceledAt || '-'}</Table.Item>
              <Table.Item className="group-data-[status=Cancelado]:font-bold group-data-[canceled=true]:font-bold">{subscriber.validUntilDate || '-'}</Table.Item>
              <Table.Item className="group-data-[status=Cancelado]:font-bold group-data-[canceled=true]:font-bold group-data-[status=Em_atraso]:font-bold"><Status>{subscriber.status}</Status></Table.Item>
              <TwoColuns>
                <SubscriberActions subscriber={subscriber} />
              </TwoColuns>
            </Table.Line>
          ))}
      </Table.Content>
      <Pagination.Root
        name={CSubscriber.paginationName}
        totalPages={paginationData.totalPages - 1}
        currentPage={paginationData.page}
        onChange={(page) => CSubscriber.setPage(page)}
      >
        <Pagination.Back />
        <Pagination.Pages />
        <Pagination.Forward />
      </Pagination.Root>
    </Table.Root>
  );
}
